import { AddAddressModel, USStates, ConfirmationModel, CountriesList } from '../models/add-address.model';
import {
  loadUSStatesSuccess,
  sendAccounts,
  setOriginalAddressSnapshot,
  updateAddress,
  updateCurrentStep,
  loadCountiresListSuccess,
  updateConfirmationNumber
} from '../actions/add-address.action';
import { createReducer, on } from '@ngrx/store';


const initialState: AddAddressModel = {
  stepIndicator: {
    currentStepIndex: 1
  },
  originalAddressSnapshot: null,
  address: {
    numberNameLines: 1,
    name: '',
    nameLine2: '',
    nameLine3: '',
    nameLine4: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: null,
    foreignAddress: false,
    foreignCountryCode: '',
    foreignCountryName: '',
    associatedAccounts: []
  },
  accounts: {
    accounts: [{
      accountId: '',
      accountName: '',
      brokerageAccountNumber: '',
      productType: '',
      noOfLinkedAddresses: 0,
      positions: [
        {
          fundName: '',
          symbol: '',
          vanguardFundId: '',
          vastAccountNumber: '',
          noOfLinkedAddresses: 0,
        }
      ]
    }]
  }
};

const initialUSStates: USStates = { allStates: [] };
const initialCountriesList: CountriesList = { countriesList: [] };
const initialConfirmationNumberState: ConfirmationModel = { confirmationNumber: '' };

export const addAddressReducer = createReducer(
  initialState,
  on(updateCurrentStep, (state, action) => (
    { ...state, currentStepIndex: action.currentStepIndex }
  )),
  on(updateAddress, (state, action) => (
    { ...state, address: action.address }
  )),
  on(sendAccounts, (state, action) => (
    { ...state, accounts: action.accounts }
  )),
  on(setOriginalAddressSnapshot, (state, action) => (
    { ...state, originalAddressSnapshot: action.snapshot }
  ))
);

export const usStatesReducer = createReducer(
  initialUSStates,
  on(loadUSStatesSuccess, (state, action) => (
    { ...state, allStates: action.allUSStates.filter((item) => item.code !== '') }
  )),
);

export const countriesListReducer = createReducer(
  initialCountriesList,
  on(loadCountiresListSuccess, (country, action) => (
    { ...country, countriesList: action.countriesList.filter((item) => item.code !== '' && item.code !== 'US') }
  )),
);

export const confirmationNumberReducer = createReducer(
  initialConfirmationNumberState,
  on(updateConfirmationNumber, (state, action) => (
    { ...state, confirmationNumber: action.confirmationNumber }
  )),
);
